/* eslint-disable array-callback-return */
import { Component } from 'react'
import { RouterProps, withRouter } from '../../../../../insfrastructure/utils/with-router-component'
import { StaticValues } from '../../../../../insfrastructure/services/static_values'
import { listJobTitles } from '../../../../../insfrastructure/services/jobs-titles'
import { listBenefits } from '../../../../../insfrastructure/services/benefits'
import { listCourses } from '../../../../../insfrastructure/services/courses'
import { createJob, updateJob } from '../../../../../insfrastructure/services/jobs'
import ResponseModal from '../../../../components/response-modal'
import { SubmitBtn } from '../../../../components/submit'
import { BasicInfoForm } from '../basic-info'
import { BenefitsForm } from '../benefits'
import { RequirementsForm } from '../requirements'
import editImg from '../../../../../assets/icons/edit.png'
import { logger } from '../../../../../insfrastructure/services/analytics'
import './styles.sass'

interface Props {
  jobpost_id: number | null,
  basic_info: BasicInfoForm,
  benefits: BenefitsForm,
  requirements: RequirementsForm,
  is_editing: boolean,
  is_duplicating?: boolean,
  changeSection: (index: number) => void
}

interface AllPropos extends Props, RouterProps {}

class Summary extends Component<AllPropos> {
  state: Record<string, any> = {
    job_types: {},
    job_titles: {},
    benefits: {},
    education_levels: {},
    courses: {},
    skills: {}
  }

  BRLReal = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  componentDidMount() {
    this.getStaticValues();
    this.listJobTitles();
    this.listBenefits();
  }

  getStaticValues = async () => {
    try {  
      const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;

      let skills: any = {};
 
      staticValues.skills.map(item => {
        skills[item.id] = item.name;
      });
      
      this.setState({ job_types: staticValues.job_type, education_levels: staticValues.education_level, skills, courses: staticValues.em_course });
    } catch (error) {}
  }

  listJobTitles = async () => {
    try {
      const response = await listJobTitles();
      
      let job_titles: any = {};

      response.results.map(item => {
        job_titles[item.id] = item.name;
      });

      this.setState({ job_titles });
    } catch (error) {}
  }

  listBenefits = async () => {
    try {        
      let benefits: any = {};

      // Obter candidate_id do localStorage se disponível
      const candidate_id = localStorage.getItem('candidate_id');
      const response = await listBenefits(candidate_id);

      response.results.map(item => {
        benefits[item.id] = item.name;
      });

      this.setState({ benefits });
    } catch (error) {
      logger.error('Erro ao carregar benefícios', error as Error);
    }
  }

  async listCourses() {
    try {
      const results = await listCourses();

      let courses: any = {};
      
      results.results.map(item => {
        courses[item.id] = item.course_name;
      });

      this.setState({ courses });
    } catch (error) {}
  }

  onSubmit = async () => {
    if(this.state.loading) return;

    try {
    
      // Construir array de skills a partir de required_skills e desired_skills
      // required_skills e desired_skills são arrays de números (IDs das habilidades)
      const required_skills_ids = Array.isArray(this.props.requirements.required_skills) 
        ? this.props.requirements.required_skills.filter((id: any) => id !== null && id !== undefined && !isNaN(parseInt(id)))
        : [];
      const desired_skills_ids = Array.isArray(this.props.requirements.desired_skills) 
        ? this.props.requirements.desired_skills.filter((id: any) => id !== null && id !== undefined && !isNaN(parseInt(id)))
        : [];
      
      // Construir array skills padronizado
      // Backend espera skill_type (snake_case) em minúsculas
      const skills = [
        ...required_skills_ids.map((skillId: any) => ({ 
          skill_id: parseInt(skillId), 
          skill_type: "required" 
        })), 
        ...desired_skills_ids.map((skillId: any) => ({ 
          skill_id: parseInt(skillId), 
          skill_type: "desired" 
        }))
      ];

      // Criar form sem required_skills e desired_skills (usar apenas skills)
      // Extrair apenas os campos necessários do requirements, excluindo required_skills e desired_skills
      const { required_skills, desired_skills, ...requirementsWithoutSkills } = this.props.requirements;
      
      const form: any = {
        ...this.props.basic_info,
        ...this.props.benefits,
        ...requirementsWithoutSkills,
        company_id: this.props.basic_info.company_id,
        minimum_experience: parseInt(this.props.requirements.minimum_experience),
        // Garantir que recommended_courses seja um array de inteiros válidos
        recommended_courses: this.props.requirements.recommended_courses ? 
          this.props.requirements.recommended_courses
            .filter((course: any) => course && course !== '')
            .map((course: any) => parseInt(course))
            .filter((course: number) => !isNaN(course)) : [],
        // Usar apenas o array skills padronizado (substitui required_skills e desired_skills)
        skills: skills
      };

      this.setState({ loading: true });

      // Se for duplicação, sempre cria uma nova vaga (não atualiza)
      const shouldCreate = !this.props.jobpost_id || this.props.is_duplicating;
      shouldCreate ? await createJob(form) : await updateJob(this.props.jobpost_id, form);

      setTimeout(() => {
        let responseData = {
            type: 'success',
            title: this.props.is_duplicating ? 'Vaga duplicada com sucesso!' : (this.props.is_editing ? 'Vaga atualizada com sucesso!' : 'Vaga criada com sucesso!')
        };
    
        this.setState({ loading: false, responseData });
      }, 500);
    } catch (error: any) {
      setTimeout(() => {
        // Função auxiliar para extrair mensagem de erro
        const getErrorMessage = (): string => {
          // Se não há resposta, é erro de rede
          if (!error.response) {
            if (error.request) {
              return 'Erro de conexão. Verifique sua internet e tente novamente.';
            }
            return error.message || 'Erro desconhecido';
          }

          const responseData = error.response.data;
          const status = error.response.status;

          // PRIORIDADE 1: Sempre tentar extrair mensagens específicas do backend primeiro
          if (responseData) {
            // Se for string, usar diretamente (mensagem específica do backend)
            if (typeof responseData === 'string') {
              return responseData;
            }
            
            // Tentar diferentes formatos de erro da API
            if (responseData.detail) {
              return typeof responseData.detail === 'string' 
                ? responseData.detail 
                : JSON.stringify(responseData.detail);
            }
            
            if (responseData.message) {
              return typeof responseData.message === 'string'
                ? responseData.message
                : JSON.stringify(responseData.message);
            }

            // Se for objeto com erros de validação por campo (ex: {quantity: ["Certifique-se de que este valor seja maior ou igual a 1"]})
            if (typeof responseData === 'object') {
              const fieldErrors: string[] = [];
              Object.keys(responseData).forEach(key => {
                const fieldError = responseData[key];
                if (Array.isArray(fieldError)) {
                  fieldErrors.push(...fieldError);
                } else if (typeof fieldError === 'string') {
                  fieldErrors.push(fieldError);
                }
              });
              
              if (fieldErrors.length > 0) {
                return fieldErrors.join('. ');
              }
            }
          }

          // PRIORIDADE 2: Apenas se não houver mensagem específica do backend, usar mensagens genéricas baseadas no status
          if (status === 400) {
            return 'Dados inválidos. Verifique os campos preenchidos.';
          }

          if (status === 401) {
            return 'Não autorizado. Faça login novamente.';
          }

          if (status === 403) {
            return 'Você não tem permissão para realizar esta ação.';
          }

          if (status === 404) {
            return 'Recurso não encontrado.';
          }

          if (status >= 500) {
            return 'Erro interno do servidor. Tente novamente em alguns minutos.';
          }

          return `Erro do servidor (${status}). Tente novamente.`;
        };

        let responseData = {
            type: 'error',
            title: this.props.is_duplicating ? 'Erro ao duplicar vaga' : (this.props.is_editing ? 'Erro ao atualizar vaga' : 'Erro ao criar vaga'),
            text: getErrorMessage()
        };
    
        this.setState({ loading: false, responseData });
      }, 500);
    }
  }

  render() {
    return (
      <div className='summary'>
        <div className='section basic-info-section'>
          <div className='section-header'>
            <h4>Dados básicos:</h4>
            <div className='edit' onClick={() => this.props.changeSection(1)}>
              <img src={editImg} alt='edit-icon' />
              <span>Editar</span>
            </div>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Nome da vaga:</p>
              <b>{this.state.job_titles[this.props.basic_info.job_title_id]}</b>
            </div>
            <div className='column'>
              <p>Quantidade de vagas:</p>
              <b>{this.props.basic_info.quantity} vaga{this.props.basic_info.quantity > 1 ? 's' : ''}</b>
            </div>
            <div className='column'>
              <p>Tipo de contratação:</p>
              <b>{this.state.job_types[this.props.basic_info.job_type?.toLowerCase()]}</b>
            </div>
          </div>
          {/* <div className='location-section'>
              <div className='location-title'>
                <img src={locationImg} alt='location-icon' />
                <p>Localização</p>
              </div>
              <b>{this.props.basic_info.street},{this.props.basic_info.number} - {this.props.basic_info.neighborhood}, {this.props.basic_info.city}, {this.props.basic_info.uf} - {this.props.basic_info.cep}</b>
          </div> */}
          <div className='about-section'>
            <h4>Sobre a vaga:</h4>
            <div dangerouslySetInnerHTML={{__html: this.props.basic_info.job_description}} />
          </div>
        </div>
        <div className='section benefits-section'>
          <div className='section-header'>
            <h4>Salário e benefícios:</h4>
            <div className='edit' onClick={() => this.props.changeSection(2)}>
              <img src={editImg} alt='edit-icon' />
              <span>Editar</span>
            </div>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Salário:</p>
              <b className='salary'>
                {
                  this.props.benefits.show_salary ?
                  this.BRLReal.format(this.props.benefits.salary) : 
                  'À combinar'
                }
              </b>
            </div>
            <div className='column'>
              <p>Benefícios:</p>
              <div className='selections'>
                {this.props.benefits.benefits.map((benefit) =>
                <b className='selection'>{this.state.benefits[benefit.benefit_id]}</b>)}
              </div>
            </div>
          </div>
        </div>
        <div className='section requirements-section'>
          <div className='section-header'>
            <h4>Requisitos:</h4>
            <div className='edit' onClick={() => this.props.changeSection(3)}>
              <img src={editImg} alt='edit-icon' />
              <span>Editar</span>
            </div>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Escolaridade:</p>
              <b>{this.state.education_levels[this.props.requirements.minimum_education]}</b>
            </div>
            <div className='column'>
              <p>Experiência mínima:</p>
              <b>{
                this.props.requirements.minimum_experience === '0' ? 
                'Indiferente' : 
                `${parseInt(this.props.requirements.minimum_experience)} ${parseInt(this.props.requirements.minimum_experience) < 2 ? 'ano' : 'anos'}`
              }</b>
            </div>
          </div>
          <div>
            <p>Habilidades obrigatórias:</p>
            <div className='selections'>
              {this.props.requirements.required_skills.map((skill: any) =>
              <b key={'required_skill_'+skill} className='selection'>{this.state.skills[skill]}</b>)}
            </div>
          </div>
          <div>
            <p>Habilidades opcionais:</p>
            <div className='selections'>
              {this.props.requirements.desired_skills.map((skill: any) =>
              <b key={'desired_skill_'+skill} className='selection'>{this.state.skills[skill]}</b>)}
            </div>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Cursos recomendados:</p>
              <div className='selections'>
                {this.props.requirements.recommended_courses.map((course) =>
                <b key={'course_'+course} className='selection'>{this.state.courses[course+'']}</b>)}
              </div>
            </div>
          </div>
        </div>
        <SubmitBtn className='primary' text={this.props.is_duplicating ? 'Duplicar Vaga' : (this.props.is_editing ? 'Atualizar Vaga' : 'Criar Vaga')} loadingText='Enviando...' loading={this.state.loading} onSubmit={this.onSubmit} />
        <ResponseModal
        render={this.state.responseData}
        type={this.state.responseData?.type}
        title={this.state.responseData?.title}
        text={this.state.responseData?.text}
        onClose={() => {
          this.setState({ responseData: null });
          this.state.responseData?.type === 'success' && this.props.navigate('/offers');
        }} />
      </div>
    )
  }
}

export default withRouter(Summary);